import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ExpiredDevice, ExpiredDeviceParams } from './types';

const tagTypes = ['ExpiredDevices', 'ExpiredDevice'];

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/reports`,
  }),
  tagTypes,
  endpoints: builder => ({
    getExpiredDevices: builder.query<ExpiredDevice[], ExpiredDeviceParams>({
      query: params => ({
        url: `/expired-devices/query`,
        params,
      }),
      providesTags: ['ExpiredDevices'],
    }),
    getExpiredDevicesI: builder.infiniteQuery<
      ExpiredDevice[],
      ExpiredDeviceParams,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/expired-devices/query',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ExpiredDevices', 'ExpiredDevice'],
    }),
  }),
});

export const { useGetExpiredDevicesQuery } = reportsApi;

export const useGetExpiredDevicesIInfiniteQuery = normalizeInfiniteQueryData(
  reportsApi.useGetExpiredDevicesIInfiniteQuery,
);
